module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1QEG6"))).then(() => parcelRequire('1iHdE'));